'use client';

import { Divider, List, ListItem, Text, TextLevels, TextMarkup, TypographyBold } from '@bytel/trilogy-react';

import { esimDescriptionApp, esimDescriptionClient } from '@tunnel/data/esim';

export function EsimDescriptionModal() {
    return (
        <>
            <Text marginless>Une fois votre commande finalisée, vous recevez un email et un SMS de confirmation.</Text>
            <Text>Connectez-vous en WiFi et téléchargez votre eSIM&nbsp;:</Text>
            <Text>
                <Text markup={TextMarkup.SPAN} marginless typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>
                    Depuis votre application Bouygues Telecom
                </Text>
                <Text markup={TextMarkup.SPAN}>&nbsp;(recommandé)</Text>
            </Text>

            <List ordered>
                {esimDescriptionApp.map((item) => (
                    <ListItem key={item.id}>
                        <Text level={TextLevels.TWO}>{item.description}</Text>
                    </ListItem>
                ))}
            </List>
            <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>Depuis votre espace client</Text>
            <List ordered>
                {esimDescriptionClient.map((item) => (
                    <ListItem key={item.description}>
                        <Text marginless level={TextLevels.TWO}>
                            {item.description}
                        </Text>
                    </ListItem>
                ))}
            </List>
            <Text>
                💡 <b>Notre astuce :</b>&nbsp;affichez le QR code sur un écran d&apos;ordinateur ou imprimez-le pour le
                scanner.
            </Text>
            <Divider />
            <Text marginless>
                Votre eSIM est disponible 1 heure après la réception de l&lsquo;e-mail de confirmation.
            </Text>
            <Text typo={TypographyBold.TEXT_WEIGHT_SEMIBOLD}>Le code PIN sera 0000.</Text>
        </>
    );
}
